import { render, staticRenderFns } from "./TalentFAQ.vue?vue&type=template&id=dd6f441e&scoped=true&"
import script from "./TalentFAQ.vue?vue&type=script&lang=js&"
export * from "./TalentFAQ.vue?vue&type=script&lang=js&"
import style0 from "./TalentFAQ.vue?vue&type=style&index=0&id=dd6f441e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6f441e",
  null
  
)

export default component.exports